import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Music, GlassWater, ConciergeBell, Users, Check, ArrowRight } from 'lucide-react';

const services = [
  { icon: Music, title: "Soirées d'entreprise", desc: "DJ set, ambiance musicale, animation pour vos soirées annuelles, lancements de produits ou célébrations." },
  { icon: Users, title: "Team Building", desc: "Atelier «Barman d'un jour» – Apprenez à créer des mocktails en équipe pour renforcer la cohésion." },
  { icon: GlassWater, title: "Cocktails séminaires", desc: "Bar à mocktails élégant pour vos pauses networking, afterworks et cocktails dînatoires." },
  { icon: ConciergeBell, title: "Service traiteur", desc: "Serveurs professionnels pour vos repas d'affaires, galas et réceptions corporate." },
];

const avantages = ["Devis personnalisé sous 24h", "Facturation entreprise", "Matériel professionnel inclus", "Adaptabilité à vos locaux", "Équipe expérimentée", "Prestation clé en main"];
const types = ["Soirée annuelle", "Lancement produit", "Séminaire", "Team building", "Afterwork", "Cocktail dînatoire", "Inauguration", "Conférence"];

export default function Entreprises() {
  return (
    <div className="fade-in" data-testid="entreprises-page">
      <section className="py-12 md:py-20 px-4 md:px-8 max-w-5xl mx-auto text-center">
        <h1 className="text-3xl sm:text-4xl font-light tracking-tight mb-4" style={{ fontFamily: 'Outfit' }}>OFFRE ENTREPRISES</h1>
        <p className="text-base text-[#A1A1AA] max-w-2xl mx-auto mb-8">{"RSX CONCEPT accompagne les entreprises dans l'organisation de leurs événements professionnels. DJ, bar à mocktails, service traiteur : des prestations sur mesure pour marquer les esprits."}</p>
        <Link to="/reservation"><Button className="bg-[#D4AF37] text-black hover:bg-[#F9E5C0] rounded-full px-8 py-3 font-semibold" data-testid="entreprise-devis">Demander un devis entreprise</Button></Link>
      </section>
      <section className="py-12 px-4 md:px-8 max-w-6xl mx-auto">
        <h2 className="text-xl font-semibold text-center mb-10" style={{ fontFamily: 'Outfit' }}>NOS SERVICES POUR LES ENTREPRISES</h2>
        <div className="grid sm:grid-cols-2 gap-6">
          {services.map(s => (
            <div key={s.title} className="bg-[#121212] border border-white/5 rounded-2xl p-6 card-hover">
              <s.icon className="w-8 h-8 text-[#D4AF37] mb-4" />
              <h3 className="font-semibold mb-2" style={{ fontFamily: 'Outfit' }}>{s.title}</h3>
              <p className="text-sm text-[#A1A1AA] leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>
      </section>
      <section className="py-12 px-4 md:px-8 max-w-5xl mx-auto">
        <h2 className="text-xl font-semibold text-center mb-8" style={{ fontFamily: 'Outfit' }}>POURQUOI CHOISIR RSX CONCEPT ?</h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3 mb-10">
          {avantages.map(a => (<div key={a} className="flex items-center gap-3 bg-[#121212] border border-white/5 rounded-xl p-4"><Check className="w-4 h-4 text-[#D4AF37] shrink-0" /><span className="text-sm">{a}</span></div>))}
        </div>
        <div>
          <h3 className="text-sm font-semibold text-[#D4AF37] mb-4" style={{ fontFamily: 'Outfit' }}>{"Types d'événements"}</h3>
          <div className="flex flex-wrap gap-2">{types.map(t => (<span key={t} className="bg-[#D4AF37]/10 text-[#D4AF37] text-xs px-3 py-1.5 rounded-full">{t}</span>))}</div>
        </div>
      </section>
      <section className="py-12 px-4 md:px-8">
        <div className="max-w-3xl mx-auto gold-bg gold-border rounded-2xl p-8 md:p-12 text-center">
          <h2 className="text-2xl font-semibold mb-3" style={{ fontFamily: 'Outfit' }}>{"FAITES DE VOTRE ÉVÉNEMENT UN SUCCÈS"}</h2>
          <p className="text-[#A1A1AA] mb-6">{"Contactez-nous pour discuter de votre projet et recevoir une proposition personnalisée."}</p>
          <Link to="/reservation"><Button className="bg-[#D4AF37] text-black hover:bg-[#F9E5C0] rounded-full px-8 py-3 font-semibold">Demander un devis gratuit</Button></Link>
        </div>
      </section>
    </div>
  );
}
